import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';
import CachedIcon from '@mui/icons-material/CachedOutlined';
import EditIcon from '@mui/icons-material/EditOutlined';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import CheckIcon from '@mui/icons-material/CheckOutlined';
import { refreshKycOnboarding } from '../../api/contacts';
import { AxiosResponse } from 'axios';
import { CustomAlertType } from '../CustomAlert';

const ContactActions = (context: any) => {
  const cellData = context.cell.getData();
  return (
    <>
      <Tooltip placement="top" title={context.props.t('BAN_CONTACT')}>
        <IconButton
          style={{ marginRight: 0 }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            context.props.banMail(cellData);
          }}
        >
          <DangerousOutlinedIcon
            fontSize="small"
            color={cellData?.is_banned ? 'error' : 'inherit'}
          />
        </IconButton>
      </Tooltip>
      <Tooltip placement="top" title={context.props.t('VERIFY_KYC')}>
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={async () => {
            try {
              const result: AxiosResponse = await refreshKycOnboarding(
                cellData.id
              );
              if (result.data.success === true) {
                context.props.openCustomAlert( result.data?.data?.message || 'KYC_UPDATED', CustomAlertType.INFO, true);
              }
              const tablePage =
                context.props?.tabulator?.current?.tabulator?.current?.table
                  ?.modules?.page;
              if (tablePage) {
                tablePage._getRemotePage();
              } else {
                console.log('NO PAGE FOUND');
              }
            } catch (error: any) {
              console.log(error);
              if (error.response?.data?.errorCode === 404) {
                const errorData = error.response?.data;
                context.props.openCustomAlert(
                  errorData.errorMessage || 'KYC_NOT_UPDATED',
                  CustomAlertType.ERROR,
                  true
                );
                return;
              }
              context.props.openCustomAlert( 'KYC_NOT_UPDATED',
                CustomAlertType.ERROR,
                true
              );
            }
          }}
        >
          <CachedIcon color="success" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top"
        title={context.props.t('MODIFY_BUSINESS_NAME_AND_VAT')}
      >
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={() => {
            context.props.openModalContactCompanies();
            context.props?.getRowData(cellData);
          }}
        >
          <EditIcon color="info" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip
        placement="top"
        title={context.props.t('MODIFY_CONTACT_PROPERTIES')}
      >
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={() => {
            context.props.openModalContact(cellData);
          }}
        >
          <PersonIcon color="info" fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip placement="top" title={context.props.t('CONTACT_INFO')}>
        <IconButton
          style={{ marginLeft: 15 }}
          onClick={() => {
            context.props.openModalContactInfo(cellData);
          }}
        >
          <CheckIcon color="success" fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default ContactActions;
